/* MEDIA PLAYER SURFACE COMPONENT *********************************************/

import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Widgets */
import TextInput from 'widget/text-input'
import { Highlight, MODE as HIGHLIGHT_MODE } from 'widget/highlight'
import { Icon, ICON } from 'widget/icon'
import InfoText from 'widget/info-text'

/* Actions */
import {
  saveName,
  assignPlaylist,
  removeAssignment,
  wrapAssetAndAssignPlaylist,
} from 'react-redux/actions/surface'
import { select } from 'react-redux/actions/highlight'
import { fetchItem as fetchPlaylistItem } from 'react-redux/actions/playlist'

/* Selectors */
import { getSurfaceItem } from 'react-redux/selectors/media-player'
import { getPlaylists } from 'react-redux/selectors/playlist'
import { getDragAndDrop } from 'react-redux/selectors/drag-and-drop'

/* Styles */
import './surface.css'

/* Single MediaPlayer Channel as part of MediaPlayer Component */
class MediaPlayerSurface extends Component {

  constructor(props) {
    super(props)
    this.state = {isDropTarget: false}
    this.dragEnterCount = 0
  }

  componentDidMount() {
    const { fetchPlaylistItem, playlistId } = this.props
    if (playlistId) fetchPlaylistItem(playlistId)
  }

  /* Edit */
  onSaveName(value) {
    const { uid, mediaPlayerId, saveName } = this.props
    saveName(mediaPlayerId, uid, value)
  }

  onEditName() {
    const { select, uid } = this.props
    select("surface", uid)
  }

  validateName(value) {
    return true
  }

  onRemoveClick(e) {
    const { mediaPlayerId, uid, removeAssignment } = this.props
    e.stopPropagation()
    removeAssignment(mediaPlayerId, uid)
  }

  /* Drag & Drop */
  onDrop(e) {
    const {
      mediaPlayerId,
      uid,
      assignPlaylist,
      wrapAssetAndAssignPlaylist
    } = this.props
    e.preventDefault()
    e.stopPropagation()
    try {
      const data = JSON.parse(e.dataTransfer.getData('text'))
      if (data.domain === "playlist") {
        assignPlaylist(mediaPlayerId, uid, data.uid)
      } else if (data.domain === "asset") {
        wrapAssetAndAssignPlaylist(mediaPlayerId, uid, data.uid)
      }
    } catch (e) {
      return
    }
    this.dragEnterCount = 0
    this.setState({isDropTarget: false})
  }

  onDragOver(e) {
    const { domain } = this.props.dragAndDrop
    e.preventDefault()
    e.stopPropagation()
    if (domain === "asset" || domain === "playlist") {
      this.setState({isDropTarget: true})
    } else {
      this.setState({isDropTarget: false})
    }
  }

  onDragEnter(e) {
    const { domain } = this.props.dragAndDrop
    this.dragEnterCount++
    //e.preventDefault()
    e.stopPropagation()
    if (domain === "asset" || domain === "playlist") {
      this.setState({isDropTarget: true})
    } else {
      this.setState({isDropTarget: false})
    }
  }

  onDragLeave(e) {
    e.preventDefault()
    e.stopPropagation()
    if(this.dragEnterCount) this.dragEnterCount--
    if (!this.dragEnterCount) this.setState({isDropTarget: false})
  }

  isSelected() {
    const { domain, uid } = this.props.highlight
    return domain === "surface" && uid === this.props.uid
  }

  isAscendant() {
    const { ascendants } = this.props.highlight
    return ascendants["surface"] && ascendants["surface"][this.props.uid]

  }

  isDescendant() {
    const { descendants } = this.props.highlight
    return descendants["surface"] && descendants["surface"][this.props.uid]
  }

  /*  Helpers */
  getListItemClass() {
    const { playlistId } = this.props
    const { isDropTarget } = this.state
    var className = "media-player-surface component"
    if (this.isSelected()) className += " highlight-selected"
    else if (this.isAscendant()) className += " highlight-ascendant"
    else if (this.isDescendant()) className += " highlight-descendant"
    if (isDropTarget) className += " drop-target"
    if (!playlistId) className += " empty-surface"
    return className
  }

  /* Rendering */

  renderRemoveButton() {
    const { t, playlistId } = this.props
    if (playlistId) {
      return (
        <button
          className="remove"
          onClick={ this.onRemoveClick.bind(this) }
          title={ t("mediaplayer:surface.removeButtonTitle") }
          >
          <Icon icon={ ICON.DELETE } size={ 24 } circle={ false } />
        </button>
      )
    }
    return null
  }

  renderItemToolbar() {
    return (
      <div className="item-toolbar">
        { this.renderRemoveButton() }
      </div>
    )
  }

  renderPlaylistLabel() {
    const { t, playlistId, playlists } = this.props
    if (playlistId && playlists[playlistId])
      return playlists[playlistId].name
    if (playlistId)
      return t("mediaplayer:surface.unknownPlaylist")
    return t("mediaplayer:surface.emptySurface")
  }


  getHighlightMode() {
    const { } = this.props
    if (this.isSelected()) return  HIGHLIGHT_MODE.SELECTED
    else if (this.isAscendant()) return  HIGHLIGHT_MODE.CHILD
    else if (this.isDescendant()) return  HIGHLIGHT_MODE.PARENT
  }

  render() {
    const {
        t,
        uid,
        surfaceName,
        playlists,
        playlistId,
        select
    } = this.props
    return (
      <li
        key={ uid }
        data-uid={ uid }
        className={ this.getListItemClass() }
        onDragEnter={ this.onDragEnter.bind(this) }
        onDragOver={ this.onDragOver.bind(this) }
        onDragLeave={ this.onDragLeave.bind(this) }
        onDrop={ this.onDrop.bind(this) }
        onClick={ (e) => { select("surface", uid) } }
      >
        <div className="border">
          <div className="detail">
            <Highlight mode={ this.getHighlightMode() } />
            <div className="label">
              <TextInput
                className="name"
                value={ surfaceName }
                placeholder={ t('mediaplayer:surface.nameInput.placeholder') }
                onSave={ this.onSaveName.bind(this) }
                onEdit={ this.onEditName.bind(this) }
                validate={ this.validateName.bind(this) }
              />
              <InfoText
                className="playlist"
                text={ this.renderPlaylistLabel() }
              />
            </div>
            { this.renderItemToolbar() }
          </div>
        </div>
      </li>
    )
  }
}

MediaPlayerSurface.propTypes = {
  mediaPlayerId: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      assignPlaylist,
      saveName,
      removeAssignment,
      wrapAssetAndAssignPlaylist,
      select,
      fetchPlaylistItem
    },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    getSurfaceItem(stateProps, ownProps.uid),
    {
      playlists: stateProps.playlist.list.items,
      dragAndDrop: getDragAndDrop(stateProps)
    },
    { highlight: stateProps.highlight },
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(MediaPlayerSurface)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/media-player/surface.jsx